import React, { Fragment } from 'react';

import Select from '@atlaskit/select';
import { layers } from '@atlaskit/theme';

import { useIntl } from 'src/hooks/intl';

import { SortOption } from '../types';

import { sortPrSelectorMessages } from './i18n';

type SortSelectProps = {
  sort: string | undefined;
  onChangeSort: (sort: string | undefined) => void;
};

export const SortSelect = (props: SortSelectProps) => {
  const intl = useIntl();
  const options: SortOption[] = [
    {
      label: 'Recently updated',
      value: '-updated_on',
    },
    {
      label: 'Least recently updated',
      value: 'updated_on',
    },
    {
      label: 'Newest',
      value: '-created_on',
    },
    {
      label: 'Oldest',
      value: 'created_on',
    },
  ];

  const { sort, onChangeSort } = props;

  const handleChange = (option: SortOption) => {
    onChangeSort(option ? option.value : undefined);
  };

  return (
    <Fragment>
      <Select
        id="sort-pr-select"
        options={options}
        spacing="compact"
        onChange={handleChange}
        value={options.filter(({ value }) => value === sort)[0] || options[0]}
        isSearchable={false}
        formatOptionLabel={(
          { label },
          { context }: { context: 'value' | 'menu' }
        ) => {
          return (
            <>
              {context === 'value'
                ? `${intl.formatMessage(
                    sortPrSelectorMessages.sortByLabel
                  )}: ${label}`
                : label}
            </>
          );
        }}
        styles={{
          menu: css => ({
            ...css,
            zIndex: layers.navigation(),
          }),
        }}
      />
    </Fragment>
  );
};
